<template>
  <div class="hello">
    <img
      src="../../public/img/login.png"
      alt=""
      style="width: 100%; height: 99.5vh"
    />
    <div class="login">
      <div class="user">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <el-form-item prop="name">
            <el-input
              v-model="ruleForm.name"
              prefix-icon="el-icon-user-solid"
              :placeholder="placeholder1"
              @focus="blurSearchFor()"
              @blur="blurSear()"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="ruleForm.password"
              prefix-icon="el-icon-lock"
              type="password"
              :placeholder="placeholder2"
              @focus="blurSearchFor1()"
              @blur="blurSear1()"
              @keyup.native.enter="login('ruleForm')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="yzm" v-if="yz">
            <el-input
              v-model="ruleForm.yzm"
              style="width:50%"
              prefix-icon="el-icon-mobile-phone"
              placeholder="验证码"
              onfocus="placeholder=''"
              onblur="placeholder='验证码'"
            ></el-input>
             <el-button type="primary" v-if="show" style="height: 2vw;margin-left:15%;width:30%" @click="send()">发送验证码</el-button>
             <el-button type="primary" v-if="!show" style="height: 2vw;margin-left:15%;width:33%;text-algin:center" >{{count}}s后重新发送</el-button>
          </el-form-item>
        </el-form>

        <!-- <el-checkbox
          name=""
          id="check"
          style=" 
            border-radius: 3px;
          "
        />
        <span style="font-size: 14px; color: #fff;padding-left:2%">记住密码</span> -->

        <button class="btn" @click="login('ruleForm')">登录</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "HelloWorld",
  data() {
    return {
      ruleForm: {},
      yz:true,
      show:true,
       timer:null,
        count:'',
      date: [],
      title: "12",
      content: "23",
      placeholder1:"用户名",
      placeholder2:"密码",
      rules: {
        name: [{ required: true, message: "请输入用户名称", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        yzm: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  methods: {
     blurSearchFor() {
      // console.log(this.placeholder2);
      if (this.placeholder1 == "用户名") {
        this.placeholder1 = "";
      }
    },
    blurSear() {
      this.placeholder1 = "用户名";
    },
    blurSearchFor1() {
      // console.log(this.placeholder1);
      if (this.placeholder2 == "密码") {
        this.placeholder2 = "";
      }
    },
    blurSear1() {
      this.placeholder2 = "密码";
    },
    send(){
      console.log(this.ruleForm)
      if(this.ruleForm.name==""||this.ruleForm.password==""||
      this.ruleForm.name==undefined||this.ruleForm.password==undefined){
        this.$alert("请填写完整用户信息")
      }else{
        let formData=new FormData()
        formData.append("username", this.ruleForm.name)
        formData.append("password", this.ruleForm.password);
         let api =   "/login/verificationCode";
           this.$ajax
            .post(api, formData)
            .then((res) => {
              if(res.data.code!=200){
                this.$alert(res.data.msg)
              }else{
                this.$alert("验证码已发送")
                this.show = false;
                const TIME_COUNT = 60;   
                if (!this.timer) {    
                this.count = TIME_COUNT;    
                this.show = false;    
                this.timer = setInterval(() => {    
                  if (this.count > 0 && this.count <= TIME_COUNT) {     
                  this.count--;     
                  } else {     
                  this.show = true;     
                  clearInterval(this.timer);     
                  this.timer = null;     
                  }    
                }, 1000)    
                }  
              }
            }).catch((e)=>{})
        console.log(111)
      }
    },

    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = new FormData();
          formData.append("username", this.ruleForm.name);
          formData.append("password", this.ruleForm.password);
          if(this.ruleForm.yzm!=undefined){
            formData.append("verificationCode", this.ruleForm.yzm);
          }
          
          let api =   "/login";
           this.$ajax
            .post(api, formData)
            .then((response) => {
              this.date = response.data;
              console.log(this.date);
              if (this.date.code != 200) {
                this.$alert(response.data.msg);
              } else {
                sessionStorage.setItem("loginName", JSON.stringify(response.data.data.realName))
                    sessionStorage.setItem("adminid", JSON.stringify(response.data.data.id))
                    sessionStorage.setItem("loginName1", JSON.stringify(response.data.data.username))
                    sessionStorage.setItem("loginName2", JSON.stringify(response.data.data.deptName))
                     sessionStorage.setItem("aliass", JSON.stringify(response.data.data.alias))
                    console.log(response.data.data)
                    this.$router.push("/index1");
                    // this.$message({
                    //   message: "登陆成功！",
                    //   type: "success",
                    // });
                    // sessionStorage.setItem("loginName", JSON.stringify(response.data.data.realName))
                    // sessionStorage.setItem("adminid", JSON.stringify(response.data.data.id))
                    // sessionStorage.setItem("loginName1", JSON.stringify(response.data.data.username))
                    // sessionStorage.setItem("loginName2", JSON.stringify(response.data.data.deptName))
                    //  sessionStorage.setItem("aliass", JSON.stringify(response.data.data.alias))
                    // console.log(response.data.data)


                //     // let apiii =  "/message/getMessage";
                //     // this.$ajax
                //     //   .get(apiii)
                //     //   .then((response) => {
                //     //     let date = response.data;
                //     //     console.log(date);
                //     //     this.title = date.data[0].title;
                //     //     this.content = date.data[0].content;
                //         this.$router.push("/index1");
                //     //   })
                //     //   .catch((error) => {
                //     //     console.log(error);
                //     //   });
                //   })
                  
                //   .catch((error) => {
                //     console.log(error);
                //   });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    clickPort() {
      // 
      // var userAgent = navigator.userAgent;
      // console.log(navigator.userAgent)
      // console.log(locator.ConnectServer())
      // if (userAgent.indexOf(".NET") > -1 || userAgent.indexOf("NT 10.0") > -1) {
      //   console.log(locator.ConnectServer())
      //   // var service = locator.ConnectServer(); // eslint-disable-line
      //   // service.Security_.ImpersonationLevel = 3;
      //   // service.InstancesOfAsync(foo, "Win32_NetworkAdapterConfiguration"); // eslint-disable-line
      // }
      // eventBus.$off('getMac'); // 关闭上一次的监听
      // eventBus.$on('getMac', (_mac) => {
      //   console.log(_mac)
      //   // alert(`获取MAC地址：${_mac}`);
      //   // this.msg = _mac;
      // });
    },
  },
  mounted(){
    this.clickPort()
    let api="/login/isVerification"
    axios.post(api).then((re)=>{
      this.yz=re.data.data
    }).catch((e)=>{})
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style  lang="scss">
* {
  margin: 0;
  padding: 0;
}
.hello{
.login {
  // border: 4px solid blue ;
  margin-top: 4vw;
  position: absolute;
            top: 45%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%);
            -moz-transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
            -o-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
  // margin: auto;
}
.btn {
  width: 15vw;
  height: 2vw;
  margin-left: 2.5vw;
  background-image: linear-gradient(0deg, #0060ff 0%, #0096ff 100%),
    linear-gradient(#00b8ff, #00b8ff);
  background-blend-mode: normal, normal;
  border: none;
  border-radius: 5px;
  font-size: 1vw;
  color: #ffffff;
  margin-left: 2.8vw;
  cursor: pointer;
}
#username {
  width: 354px;
  height: 51px;
  border-radius: 5px;
  border: solid 2px #00c0ff;
  opacity: 0.6;
  font-size: 18px;
}
#password {
  width: 354px;
  height: 51px;
  border-radius: 5px;
  border: solid 2px #00c0ff;
  opacity: 0.6;
  font-size: 18px;
}
input::-webkit-input-placeholder {
  color: #fff;
}
.el-input__inner {
  background-color:rgba(255, 255, 255, 0.1) ;
  color:#ffff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  height: 2.5vw;
}
.el-checkbox__inner{
  background-color:rgba(255, 255, 255, 0.1) ;
  color:#ffff;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.el-input{
  width: 20vw;
  height: 2vw;
  margin-bottom: 0.8vw;
}}
</style>
